<template>
  <div class="panel-dropdown eng-titles">
    <a href="#">
      <span class="mr-2 ml-2">{{ rooms.length }} {{ $t("HomeHeader.Room") }}</span>
      <span class="mr-2 ml-2">،</span>
      <span class="mr-2 ml-2">{{ guests }}  {{ $t("HomeHeader.Guest") }}</span>
    </a>

    <div class="panel-dropdown-content eng-titles">
      <a @click="close" class="close-menu" ><i class="icon_set_1_icon-77"></i></a>
      <div v-for="(room, index) in rooms" :key="index" class="room">
        <div v-if="room.canRemove">
          <div class="d-flex justify-content-between border-top pt-3 pb-3">
            <span class="text-warning align-middle"
              >{{ $t("HomeHeader.DeleteRoom") }} {{ index + 1 }}</span
            >
            <a href="#">
              <strong
                class="icon_set_1_icon-67 text-danger"
                style="font-size: 20px"
                @click="removeRoom(room, index)"
              ></strong>
            </a>
          </div>
        </div>

        <pdk-qty
          :title='$t("FastTrack.Adult")'
          :min="1"
          :max="9"
          :default="room.adults"
          :canIncerement="canAddGuestOnRoom(index)"
          @valueChange="onAdultsChange($event, index)"
        />

        <pdk-qty
          :title='$t("FastTrack.Child")'
          :min="0"
          :max="9"
          :default="room.kinderAge.length"
          :canIncerement="canAddGuestOnRoom(index)"
          @valueChange="onChildrenChange($event, index)"
        />

        
   <div  style="margin-bottom:5px" class="row">
     <div style="margin-bottom:2px" v-for="i in room.children" :key="i"  class="form-group col-md-6 col-sm-6 col-xs-12">
          <!-- <label>City <sup>*</sup>
											</label> -->
                      
          <select v-model="room.kinderAge[i-1]" 
           style="display: unset;" name="kinderAge" class="form-control">
            <option :value="0" > {{ $t("FastTrack.Infant") }}</option>
            <option :value="2">2 {{ $t("Years") }}</option>
            <option :value="3">3 {{ $t("Years") }}</option>
            <option :value="4">4 {{ $t("Years") }}</option>
            <option :value="5">5 {{ $t("Years") }}</option>
            <option :value="6">6 {{ $t("Years") }}</option>
            <option :value="7">7 {{ $t("Years") }}</option>
            <option :value="8">8 {{ $t("Years") }}</option>
            <option :value="9">9 {{ $t("Years") }}</option>
            <option :value="10">10 {{ $t("Years") }}</option>
            <option :value="11">11 {{ $t("Years") }}</option>
            <option :value="12">12 {{ $t("Years") }}</option>
          </select>
        </div>
    
   </div>
        <!-- <pdk-qty title="نوزاد" :min="0" :max="9" :default="0" 
         :canIncerement="canAddGuestOnRoom(index)"
          @valueChange="onInfantChange($event, index)"
        /> -->


      </div>


      <hr />

      <button
        type="button"
        class="btn btn-outline-primary btn-block"
        @click="addRoom"
      >
        <span class="icon_set_1_icon-11"></span>
        <span>{{ $t("HomeHeader.AddRoom") }}</span>
      </button>
    </div>
  </div>
</template>

<script>
import PdkQty from "../components/PdkQty";

export default {
  name: "pdk-room",
  props: {
    currentRooms: { type: Array },
    // initial guest room
    room: {
      type: Object,
      default: () => ({ canRemove: false, infants: 0, children: 0, adults: 2 , kinderAge:[] }),
    },

    // room limitation count
    roomLimitation: {
      type: Number,
      default: 4,
    },

    // guest limitation count = person per room
    guestLimitationPerRoom: {
      type: Number,
      default: 9,
    },

    // infant limitation per room
    infantLimitationPerRoom: {
      type: Number,
      default: 0,
    },
  },
  data: () => ({
    rooms: [],
    guests: 2,
    maxPassenger: 9,
    max: 0,
    adultDefault: 2,
     selectedKinderAge: [],
      params: {},
  }),
 
  computed() {
    return this.currentRooms;
  },
  created() {
 
    this.initialGuestsRoom();
  },

  components: { PdkQty },

  mounted: function () {
    this.initialComponent();

  },

  methods: {
  close() {
   this.$el.classList.remove("active");
  },
    initialComponent() {
      const vm = this;
      const close_panel_dropdown = function () {
        vm.$el.classList.remove("active");
      };

      vm.$el.querySelector("a").addEventListener("click", function (e) {
        if (vm.$el.classList.contains("active")) {
          close_panel_dropdown();
        } else {
          close_panel_dropdown();
          vm.$el.classList.add("active");
        }

        e.preventDefault();
      });

      // Closes dropdown on click outside the conatainer
      var mouse_is_inside = false;

      vm.$el.addEventListener("mouseenter", function () {
        mouse_is_inside = true;
      });

      vm.$el.addEventListener("mouseleave", function () {
        mouse_is_inside = false;
      });

      document.querySelector("body").addEventListener("mouseup", function () {
        if (!mouse_is_inside) close_panel_dropdown();
      });
    },

    initialGuestsRoom() {

this.params = this.$route.query;
if (Object.keys(this.params).length ){
var rooms = JSON.parse(this.params.rooms);
 this.rooms = rooms;
}else {
    this.rooms.push(this.room);
}
 
    },

    onInfantChange: function (val, idx) {
      // if (!this.canAddGuestOnRoom(idx)) return;

      this.rooms[idx].infants = val;
      this.getGuests();

      this.roomEvent();
    },
    onChildrenChange: function (val, idx) {
      // if (!this.canAddGuestOnRoom(idx)) return;
      this.rooms[idx].children = val;
      this.getGuests();

      this.roomEvent();
    },

    onAdultsChange: function (val, idx) {
      // if (!this.canAddGuestOnRoom(idx)) return;

      this.rooms[idx].adults = val;
      this.getGuests();

      this.roomEvent();
    },

    canAddGuestOnRoom(idx) {
      const value = this.guests < this.maxPassenger;

      return value;
    },

    addRoom: function () {
      if (this.roomLimitation <= this.rooms.length) return;
      if (this.guests >= this.maxPassenger) return;
      this.rooms.push({
        canRemove: true,
        infants: this.infantLimitationPerRoom,
        children: 0,
        adults: 2,
        kinderAge:[]
      });

      this.getGuests();
      this.roomEvent();
    },

    removeRoom: function (room) {
      this.rooms.splice(this.rooms.indexOf(room), 1);
      this.getGuests();

      this.roomEvent();
    },

    getGuests: function () {
      let total = 0;
      this.rooms.forEach((itm) => {
        total += itm.infants + itm.children + itm.adults;
      });
      this.max = this.maxPassenger - total;
      if (this.max < 2) {
        this.adultDefault = 1;
      }
      this.guests = total;
    },

    roomEvent: function () {
      let arr = [];
      this.rooms.forEach((itm, index) => {
        var canRemove = true;
        if (index ===0) {canRemove = false} else {canRemove = true}
        arr.push({
           canRemove: canRemove,
          infants: itm.infants,
          children: itm.children,
          adults: itm.adults,
          kinderAge: itm.kinderAge
          
        });

        
      });
      this.$emit("roomChanged", arr);
    },
  },

  watch: {
    rooms: function () {
      this.roomEvent();
    },
  },
};
</script>

<style scoped>
.close-menu {
  font-size: 20px;
    cursor: pointer;
}

.close-menu :hover {
  color: #e04f67;
}
.panel-dropdown-content {
  padding-bottom: 15px;
  overflow-y: auto;
  max-height: 400px;
}
.panel-dropdown .panel-dropdown-content:after {
  content: unset !important;
}
.panel-dropdown .panel-dropdown-content {
  /* width: 100% !important; */
}

.room {
      margin-top: 8px;
}
@media only screen and (max-width: 600px) {
  .panel-dropdown-content {
  position: inherit;
}
  .panel-dropdown .panel-dropdown-content {
    width: 100% !important;
  }
}

</style>